import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';

interface MaybeNodeDetailsGql {
  __typename?: string;
  type?: string;
}

interface MinimalProcessTaskNodeDetailsGraphQL {
  __typename: 'ProcessTaskNodeDetailsNode';
  type: ProcessFlowchartNodeDetailsType.TASK_NODE_DETAILS;
}
export function isTaskNodeDetailsGQL(
  data?: MaybeNodeDetailsGql
): data is MinimalProcessTaskNodeDetailsGraphQL {
  return data?.__typename === 'ProcessTaskNodeDetailsNode' && data.type != null;
}

interface MinimalProcessRouterNodeDetailsGraphQL {
  __typename: 'ProcessRouterNodeDetailsNode';
  type: ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS;
}

export function isRouterNodeDetailsGQL(
  data?: MaybeNodeDetailsGql
): data is MinimalProcessRouterNodeDetailsGraphQL {
  return data?.__typename === 'ProcessRouterNodeDetailsNode' && data.type != null;
}

interface MinimalProcessRootNodeDetailsGraphQL {
  __typename: 'ProcessRootNodeDetailsNode';
  type: ProcessFlowchartNodeDetailsType.ROOT_NODE_DETAILS;
}

export function isRootNodeDetailsGQL(
  data?: MaybeNodeDetailsGql
): data is MinimalProcessRootNodeDetailsGraphQL {
  return data?.__typename === 'ProcessRootNodeDetailsNode' && data.type != null;
}

interface MinimalProcessOutputNodeDetailsGraphQL {
  __typename: 'ProcessOutputNodeDetailsNode';
  type: ProcessFlowchartNodeDetailsType.OUTPUT_NODE_DETAILS;
}

export function isOutputNodeDetailsGQL(
  data?: MaybeNodeDetailsGql
): data is MinimalProcessOutputNodeDetailsGraphQL {
  return data?.__typename === 'ProcessOutputNodeDetailsNode' && data.type != null;
}

interface MinimalProcessEndNodeDetailsGraphQL {
  __typename: 'ProcessEndNodeDetailsNode';
  type: ProcessFlowchartNodeDetailsType.END_NODE_DETAILS;
}

export function isEndNodeDetailsGQL(data?: MaybeNodeDetailsGql): data is MinimalProcessEndNodeDetailsGraphQL {
  return data?.__typename === 'ProcessEndNodeDetailsNode' && data.type != null;
}
